import React from 'react';
import { Link } from 'react-router-dom';
import { LogoSmall } from './Logo';

const Footer = () => (
  <footer className="bg-[#0a0203] text-white py-12">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
        {/* Brand */}
        <div className="col-span-2 md:col-span-1">
          <LogoSmall />
          <p className="text-gray-400 text-sm mt-4">Premium freeze drying technology for the modern home.</p>
        </div>
        
        {/* Products */}
        <div>
          <h4 className="font-semibold mb-4">Products</h4>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><Link to="/products" className="hover:text-[#fdc31c]">All Products</Link></li>
            <li><Link to="/products?category=freeze-dryer" className="hover:text-[#fdc31c]">Freeze Dryers</Link></li>
            <li><Link to="/products?category=accessory" className="hover:text-[#fdc31c]">Accessories</Link></li>
            <li><Link to="/compare" className="hover:text-[#fdc31c]">Compare Models</Link></li>
            <li><Link to="/commercial" className="hover:text-[#fdc31c]">Business Solutions</Link></li>
          </ul>
        </div>
        
        {/* Resources */}
        <div>
          <h4 className="font-semibold mb-4">Resources</h4>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><Link to="/blog" className="hover:text-[#fdc31c]">Blog</Link></li>
            <li><Link to="/recipes" className="hover:text-[#fdc31c]">Recipes</Link></li>
            <li><Link to="/documents" className="hover:text-[#fdc31c]">Documents & Manuals</Link></li>
            <li><Link to="/resources/videos" className="hover:text-[#fdc31c]">Video Gallery</Link></li>
            <li><Link to="/resources/faq" className="hover:text-[#fdc31c]">FAQ</Link></li>
            <li><Link to="/financing" className="hover:text-[#fdc31c]">Financing Options</Link></li>
          </ul>
        </div>
        
        {/* Support */}
        <div>
          <h4 className="font-semibold mb-4">Support</h4>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><Link to="/customer-support" className="hover:text-[#fdc31c]">Customer Support</Link></li>
            <li><Link to="/contact" className="hover:text-[#fdc31c]">Contact Us</Link></li>
            <li><Link to="/track-order" className="hover:text-[#fdc31c]">Track Order</Link></li>
            <li><Link to="/warranty" className="hover:text-[#fdc31c]">Warranty</Link></li>
            <li><Link to="/about" className="hover:text-[#fdc31c]">About Us</Link></li>
            <li><Link to="/report-bug" className="hover:text-[#fdc31c]">Report a Bug</Link></li>
            <li><a href="https://freezedryersupport.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#fdc31c]">Customer Portal</a></li>
          </ul>
        </div>
        
        {/* Legal */}
        <div>
          <h4 className="font-semibold mb-4">Legal</h4>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><Link to="/privacy-policy" className="hover:text-[#fdc31c]">Privacy Policy</Link></li>
            <li><Link to="/terms-of-use" className="hover:text-[#fdc31c]">Terms of Use</Link></li>
            <li><Link to="/return-policy" className="hover:text-[#fdc31c]">Return Policy</Link></li>
            <li><Link to="/cancellation-policy" className="hover:text-[#fdc31c]">Cancellation Policy</Link></li>
            <li><Link to="/accessibility" className="hover:text-[#fdc31c]">Accessibility</Link></li>
          </ul>
        </div>
      </div>
      
      {/* Programs Row */}
      <div className="border-t border-gray-800 mt-8 pt-8">
        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
          <Link to="/refer-a-friend" className="hover:text-[#fdc31c]">Refer a Friend</Link>
          <span className="text-gray-600">|</span>
          <Link to="/affiliate-program" className="hover:text-[#fdc31c]">Affiliate Program</Link>
          <span className="text-gray-600">|</span>
          <Link to="/financing" className="hover:text-[#fdc31c]">Financing</Link>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500 text-sm">
        <p>&copy; 2026 HomeLyph. A product of Chinook Manufacturing Inc.</p>
        <p className="mt-2">All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
